import { React, useEffect, useState, useRef } from "react";
import { Link, useParams, Navigate, useNavigate } from "react-router-dom";
import * as CONST from "../../component/config/Constant";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import Form from "../../component/utilities/Forms";
import "../../assets/css/auth.css";
import { FiLock, FiMail, FiArrowLeft, FiShield } from "react-icons/fi";

export default function PasswordReset() {
  let { token } = useParams();
  let [isExpired] = useState(false);
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  let [confirmPassword, setConfirmPassword] = useState("");
  let [isPasswordEqual, setIsPasswordEqual] = useState({});
  const [loading, setloaing] = useState(false);
  const [validate, setValidate] = useState({});
  const navigate = useNavigate();
  const dataFetchedRef = useRef(false);

  async function fetchData() {
    if (token) {
      let tokenData = JSON.parse(atob(token.split('.')[1]));
      setEmail(tokenData.userEmail || "");
    }
  }

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    fetchData();
  }, []);

  const validateResetPassword = async () => {
    let isValid = true;
    let validator = Form.validator({
      password: { value: password, isRequired: true, minLength: 8, label: "new password", isSymbol: true },
      confirmPassword: { value: confirmPassword, isRequired: true, minLength: 8, isSymbol: true, label: "confirm password" },
    });
    if (validator !== null) {
      setValidate({ validate: validator.errors });
      isValid = false;
    } else {
      if (password !== confirmPassword) {
        setIsPasswordEqual({ status: "yes", msg: "Passwords do not match" });
        isValid = false;
      } else {
        setValidate({ validate: "" });
        setIsPasswordEqual({});
      }
    }
    return isValid;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    const valid = await validateResetPassword();
    if (valid) {
      setloaing(true);
      await axios.post(CONST.RESET_PASSWORD + '/' + token, {
        email, new_password: password, confirm_password: confirmPassword,
      })
        .then((response) => {
          setloaing(false);
          if (response?.data?.status === 'success') {
            toast.success(response.data.message);
            navigate("/login");
          } else {
            toast.error(response.data.message);
          }
        })
        .catch(() => { setloaing(false); toast.error("There was an error."); });
    }
  };

  if (isExpired) return <Navigate to="/forget-password" />;

  return (
    <>
      <Loading loading={loading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <section className="auth-page">
        <div className="auth-page-inner">
          <div className="auth-form-panel">
            <div className="auth-form-wrapper">
              <Link to="/login" className="auth-back-link"><FiArrowLeft /> Back to Login</Link>
              <div className="auth-form-header">
                <h3 className="auth-form-title">Reset Password</h3>
                <p className="auth-form-subtitle">Set a new password for your account</p>
              </div>

              <div className="auth-info-box">
                <FiShield className="auth-info-icon" />
                <span>Min 8 characters with at least one special character</span>
              </div>

              <form className="auth-form" method="POST" onSubmit={submitForm} autoComplete="off">
                <div className="auth-input-group">
                  <label className="auth-label"><FiMail size={14} /> Email</label>
                  <input type="email" className="form-control auth-input" value={email} readOnly disabled />
                </div>

                <div className="auth-input-group">
                  <label className="auth-label"><FiLock size={14} /> New Password</label>
                  <input
                    type="password"
                    className={`form-control auth-input ${validate.validate?.password ? "is-invalid" : ""}`}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {validate.validate?.password && <div className="invalid-feedback d-block">{validate.validate.password[0]}</div>}
                </div>

                <div className="auth-input-group">
                  <label className="auth-label"><FiLock size={14} /> Confirm Password</label>
                  <input
                    type="password"
                    className={`form-control auth-input ${validate.validate?.confirmPassword ? "is-invalid" : ""}`}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  {validate.validate?.confirmPassword && <div className="invalid-feedback d-block">{validate.validate.confirmPassword[0]}</div>}
                </div>

                {isPasswordEqual.msg && <div className="auth-error-msg">{isPasswordEqual.msg}</div>}

                <button type="submit" className="btn auth-submit-btn">Reset Password</button>
              </form>

              <div className="auth-alt-link">
                Remember your password? <Link to="/login"><strong>Sign in</strong></Link>
              </div>
            </div>
          </div>

          <div className="auth-brand-panel">
            <div className="auth-brand-content">
              <h2 className="auth-brand-title">Set New Password</h2>
              <p className="auth-brand-text">Create a strong password to secure your account. Must be at least 8 characters with a special character.</p>
              <img className="auth-brand-illustration" src={process.env.PUBLIC_URL + "/assets/img/login/auth-illustration.svg"} alt="Reset Password" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
